module.exports = __webpack_public_path__ + "img/gogame-link.038dc6f4.png";